module.exports = __webpack_public_path__ + "static/img/wzry-enterpriseVision1.f7a6a6ca.png";